import React from 'react'
import {
  WhatsappShareButton,
  FacebookShareButton,
  TelegramShareButton,
} from 'react-share'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import {
  Sheet,
  SheetCloseButton,
  SheetOverlay,
  SheetContent,
  SheetTitle,
} from '@wartek-id/sheet-v1'
import { List, ListItem } from '@wartek-id/list'
import { useToast } from '@wartek-id/toast'
import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import { getUrlsFromText } from 'utils/text'

import WhatsappIcon from 'assets/icons/whatsapp-square.svg'
import FacebookIcon from 'assets/icons/facebook-square.svg'
import TelegramIcon from 'assets/icons/telegram-square.svg'

export type SocialFunnel = 'whatsapp' | 'facebook' | 'telegram' | 'clipboard'

interface SocialShareDrawerProps {
  isOpen: boolean
  onClose: () => void
  shareUrl: string
  shareText?: string
  title?: string
  linkOnlyUrl?: string
  linkOnlyOnCopy?: boolean
  onShareButtonClicked?: (SocialFunnel: SocialFunnel) => void
}

export function SocialShareDrawer({
  isOpen,
  onClose,
  shareUrl,
  shareText,
  linkOnlyUrl,
  linkOnlyOnCopy = false,
  title = 'Bagikan',
  onShareButtonClicked = () => {},
}: SocialShareDrawerProps) {
  const toast = useToast()

  const onClickShareButton = (funnel) => {
    onShareButtonClicked(funnel)
    onClose()
  }
  const shareUrls = getUrlsFromText(shareText) || []

  return (
    <Sheet isOpen={isOpen} onClose={onClose} sheetSize="auto">
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto !z-[1000]">
        <SheetCloseButton />
        <SheetTitle bold bordered>
          {title}
        </SheetTitle>
        <div className="px-2 pb-2">
          <List type="menu" bold>
            <ListItem
              style={{ padding: '12px 8px', width: '100%' }}
              as={WhatsappShareButton}
              url={shareUrl}
              title={shareText}
              onClick={() => onClickShareButton('whatsapp')}
            >
              <div className="flex flex-row">
                <WhatsappIcon aria-hidden className="mr-3" />
                <Text variant="heading-sm">Whatsapp</Text>
              </div>
            </ListItem>
            <ListItem
              style={{ padding: '12px 8px', width: '100%' }}
              as={FacebookShareButton}
              url={
                shareUrl !== ' ' ? shareUrl : shareUrls.length && shareUrls[0]
              }
              quote={shareText}
              onClick={() => onClickShareButton('facebook')}
            >
              <div className="flex flex-row">
                <FacebookIcon aria-hidden className="mr-3" />
                <Text variant="heading-sm">Facebook</Text>
              </div>
            </ListItem>
            <ListItem
              style={{ padding: '12px 8px', width: '100%' }}
              as={TelegramShareButton}
              url={shareUrl}
              title={shareText}
              onClick={() => onClickShareButton('telegram')}
            >
              <div className="flex flex-row">
                <TelegramIcon aria-hidden className="mr-3" />
                <Text variant="heading-sm">Telegram</Text>
              </div>
            </ListItem>
            <CopyToClipboard
              text={
                linkOnlyOnCopy
                  ? linkOnlyUrl || shareUrl
                  : `${shareText} ${shareUrl}`
              }
              onCopy={() => {
                toast({ message: 'Berhasil disalin', type: 'success' })
                onClickShareButton('clipboard')
              }}
            >
              <ListItem>
                <div className="flex flex-row">
                  <Icon as="i" aria-hidden className="mr-3">
                    link
                  </Icon>
                  <Text variant="heading-sm">Salin Link</Text>
                </div>
              </ListItem>
            </CopyToClipboard>
          </List>
        </div>
      </SheetContent>
    </Sheet>
  )
}
